import React from 'react';
import './framework.scss';
import {frameworkBullets, frameworkEng, frameworkHun, frameworkTitle, frameworkImage} from "../demo_page/content";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

class Framework extends React.Component {
   componentDidMount() {
      setTimeout(function () {
         document.querySelector(".loader-wrapper").style = "display: none";
      }, 2000);
   }
   render() {
      const isEng = this.props.language && this.props.language === 'ENG';

      const list1 = [];
      const list2 = [];

      frameworkBullets.forEach((val, i) => {
         const bulletPoint =  <li key={i}>
            <div className="feature-icon" style={{color: val.color}}>
               <FontAwesomeIcon icon={val.icon} />
            </div>
            <div className="feature-subtitle">
               <h3>{isEng ? val.engTitle : val.hunTitle}</h3>
            </div>
            <div>
               <p>{isEng ? val.engText : val.hunText}</p>
            </div>
         </li>;

         (i < frameworkBullets.length / 2) ? list1.push(bulletPoint) : list2.push(bulletPoint);
      });
      
      return (
         <section id="framework" className="feature feature-personalized">
            <div className="feature-ipad">
               <img src={frameworkImage.src} className={"ipad-image"} alt={isEng ? frameworkImage.altEng : frameworkImage.altHun} />
            </div>
            <div className="feature-decor">
               <div className="feature-circle1"><img src="assets/images/feature2.png" alt="" /></div>
            </div>
            <div className="container">
               <div className="row">
                  {/*<div className="feature-phone">*/}
                  {/*   <img src={frameworkImage.src} className="img-fluid" alt={isEng ? frameworkImage.altEng : frameworkImage.altHun} />*/}
                  {/*</div>*/}
                  <div className="offset-lg-4 col-lg-8">
                     <div className="row">
                        <div className="col-sm-12 mrgn-md-top">
                           <h2 className="title">{isEng ? frameworkTitle.eng : frameworkTitle.hun}</h2>
                           <p className="caption-about">{isEng ? frameworkEng : frameworkHun}</p>
                        </div>
                        <div className="col-12 col-md-6">
                           <ul className="feature-style">
                              {list1}
                           </ul>
                        </div>
                        <div className="col-12 col-md-6 sm-m-top">
                           <ul className="feature-style">
                             {list2}
                           </ul>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </section>
      );
   }
}


export default Framework;


// WEBPACK FOOTER //
// ./src/components/framework.js